module.exports = __webpack_public_path__ + "static/media/butterfly.13243bb9.svg";